import { render } from "./Error404.vue?vue&type=template&id=198f572c"
import script from "./Error404.vue?vue&type=script&lang=js"
export * from "./Error404.vue?vue&type=script&lang=js"

import exportComponent from "/data/tfs-agent-build/agent/_work/7/s/30-Frontend/Frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Error404.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "198f572c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('198f572c', __exports__)) {
    api.reload('198f572c', __exports__)
  }
  
  module.hot.accept("./Error404.vue?vue&type=template&id=198f572c", () => {
    api.rerender('198f572c', render)
  })

}


export default __exports__